
  import * as types from "./actiontypes";

  const initialState = {
    
    resumeFullDetails: null,
    resumeProjectsData: [],
    summary: '',
    skills :[],
    personalDetails: {
      name: '',
      email: '',
      phone: '',
      address: ''
    },
    projects: [],
    educationDetails: [],
    certifications: [],
    currentSection: {section : "" , id : 0, isRedirect : false}, 
    isOpenInterested : false

  };

  const resumeBuilderReducer = (state = initialState, action) => {
    switch (action.type) {

      case types.JS_FULL_RESUME_DETAILS_SUCCESS:
        return {
          ...state,
          resumeFullDetails: action.payload,
        };
          case types.RESUMES_PROJECTS_DATA:
          return {
            ...state,
            resumeProjectsData: action.payload,
          };

          case  types.UPDATE_SUMMARY:
            return {
              ...state,
              summary: action.payload
            };
  
            case  types.UPDATE_SKILLS:
              return {
                ...state,
                skills: action.payload
              };
          case  types.UPDATE_PERSONAL_DETAILS:
            return {
              ...state,
              personalDetails: {
                ...state.personalDetails,
                ...action.payload
              }
            };
          case  types.UPDATE_PROJECTS:
            return {
              ...state,
              projects: action.payload
            };
          case  types.UPDATE_EDUCATION_DETAILS:
            return {
              ...state,
              educationDetails: action.payload
            };
          case  types.UPDATE_CERTIFICATIONS:
            return {
              ...state,
              certifications: action.payload
            };
  
            case types.SET_CURRENT_SECTION: 
            return {
              ...state,
              currentSection: action.payload,
            };
            
            case types.OPEN_SHARE_INTERESTED:
                return {
                  ...state,
                  isOpenInterested: true,
                };
          
              case types.CLOSE_SHARE_INTERESTED:
                return {
                  ...state,
                  isOpenInterested: false,
                };

          case  types.RESET_RESUME:
            return initialState;


      default:
        return state;
    }
  };

  export default resumeBuilderReducer;